import { AsyncPipe, NgClass } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DataKanban } from '@iupics-components/models/kanban-interface';
import { TextLimitPipe } from '@iupics-util/pipes/text-limit/text-limit.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { DocServerUrlPipe } from '../../../../../iupics-util/pipes/doc-server-url/doc-server-url.pipe';

@Component({
  selector: 'iu-kanban-card-ui',
  templateUrl: './kanban-card-ui.component.html',
  styleUrls: ['./kanban-card-ui.component.scss'],
  standalone: true,
  imports: [NgClass, TooltipModule, AsyncPipe, TextLimitPipe, DocServerUrlPipe],
})
export default class KanbanCardUiComponent implements OnInit {
  @Input()
  datasKanban: DataKanban;
  @Input()
  tableName: string;
  isMobile = false;
  constructor() {}

  ngOnInit() {
    this.isMobile = document.documentElement.clientWidth <= 480;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    event.stopPropagation();
    this.isMobile = document.documentElement.clientWidth <= 480;
  }
}
